import React from 'react';
import PropTypes from 'prop-types';
import { Button, Badge } from '@dev-go4ellis/go4-design-system';
import HowMathWorks from '../HowMathWorks';
import './Hero.scss';

const STATS = [
  { title: 'You set the rate', body: 'Go4 never sets or marks up pay' },
  { title: 'Free to post', body: 'Billed only on hours worked' },
  { title: 'No contracts', body: 'No subscriptions or minimums' },
];

const ArrowDown = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 8 }}><path d="M12 5v14M19 12l-7 7-7-7" /></svg>
);

const Hero = ({ onEstimate, onPostJob }) => (
  <section className="pl-hero">
    <div className="pl-hero__inner">
      <div className="pl-hero__content">
        <div className="pl-hero__badge-wrap">
          <Badge tone="brand" variant="soft">One flat 17.5% service fee</Badge>
        </div>
        <h1 className="pl-hero__title">Know what athletic trainer coverage costs before you post.</h1>
        <p className="pl-hero__lead">You set the hourly rate. Go4 adds one 17.5% service fee that covers licensure verification, payments, insurance and documentation. No subscriptions, no per-seat pricing, no charge until a shift is worked.</p>
        <p className="pl-hero__note">Run the numbers in 30 seconds — no account required.</p>
        <div className="pl-hero__actions">
          <Button variant="primary" size="lg" onClick={onEstimate}>Estimate your cost<ArrowDown /></Button>
          <Button variant="secondary" size="lg" onClick={onPostJob}>Post a job free</Button>
        </div>
        <div className="pl-hero__stats">
          {STATS.map((s) => (
            <div key={s.title} className="pl-hero__stat">
              <div className="pl-hero__stat-title">{s.title}</div>
              <div className="pl-hero__stat-body">{s.body}</div>
            </div>
          ))}
        </div>
      </div>
      <HowMathWorks />
    </div>
  </section>
);

Hero.propTypes = {
  onEstimate: PropTypes.func,
  onPostJob: PropTypes.func,
};

Hero.defaultProps = {
  onEstimate: () => {},
  onPostJob: () => {},
};

export default Hero;
